export enum RuleType {
  AbsoluteDataValue,
  AverageDailyPercentage,
  Idle,
  AverageDailyPercentageGT
}